export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-primary-50 border-t border-primary-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 md:col-span-1">
            <img
              src="https://static.readdy.ai/image/61892072331720d5ae52870a50f3ccd8/df0d25b7383130e226bb00168de2225d.png"
              alt="Primor Odontologia e Saúde Integrada"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-gray-500 text-sm leading-relaxed">
              Cuidando do seu sorriso com qualidade, carinho e preços acessíveis em São Paulo.
            </p>
          </div>

          {/* Links */}
          <div>
            <h5 className="font-bold text-primary-700 text-sm mb-4 uppercase tracking-wider">Navegação</h5>
            <ul className="space-y-2">
              {[
                { label: "Sobre", href: "#sobre" },
                { label: "Serviços", href: "#servicos" },
                { label: "Como Funciona", href: "#como-funciona" },
                { label: "Depoimentos", href: "#depoimentos" },
                { label: "Contato", href: "#contato" },
              ].map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(l.href); }}
                    className="text-gray-500 hover:text-secondary text-sm transition-colors cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h5 className="font-bold text-primary-700 text-sm mb-4 uppercase tracking-wider">Serviços</h5>
            <ul className="space-y-2">
              {["Limpeza e Prevenção", "Restauração", "Prótese Dentária", "Clareamento", "Urgência"].map((s) => (
                <li key={s}>
                  <a
                    href="#servicos"
                    onClick={(e) => { e.preventDefault(); scrollTo("#servicos"); }}
                    className="text-gray-500 hover:text-secondary text-sm transition-colors cursor-pointer"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="sm:col-span-2 md:col-span-1">
            <h5 className="font-bold text-primary-700 text-sm mb-4 uppercase tracking-wider">Contato</h5>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-2-line text-secondary mt-0.5 flex-shrink-0"></i>
                <span className="text-gray-500 text-sm">Av. Aratãs 568, São Paulo – SP</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-whatsapp-line text-secondary flex-shrink-0"></i>
                <a href="https://wa.me/5511999999999" target="_blank" rel="nofollow noreferrer" className="text-gray-500 hover:text-secondary text-sm cursor-pointer">
                  (11) 91983-0222
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-secondary mt-0.5 flex-shrink-0"></i>
                <span className="text-gray-500 text-sm leading-relaxed">
                  Seg–Sex: 08h–20h<br />
                  Sábado: 08h–14h
                </span>
              </li>
            </ul>

            {/* Social */}
            <div className="flex gap-3 mt-5">
              {[
                { icon: "ri-instagram-line", href: "#", label: "Instagram" },
                { icon: "ri-facebook-box-line", href: "#", label: "Facebook" },
                { icon: "ri-whatsapp-line", href: "https://wa.me/5511999999999", label: "WhatsApp" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center bg-primary-100 hover:bg-secondary text-primary-700 hover:text-white rounded-lg transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 md:mt-10 pt-5 md:pt-6 border-t border-primary-100 flex flex-col items-center gap-3 md:flex-row md:justify-between md:gap-4">
          <p className="text-gray-400 text-xs text-center md:text-left">
            &copy; 2026 Primor Odontologia e Saúde Integrada. Todos os direitos reservados.
          </p>
          <p className="text-gray-400 text-xs hidden md:block">
            CRO-SP — Clínica de Odontologia em São Paulo
          </p>
          <a
            href="https://www.twogatheragency.com"
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center gap-2 group cursor-pointer"
            aria-label="Desenvolvido por Twogather Agency"
          >
            <span className="text-gray-400 text-xs group-hover:text-gray-600 transition-colors whitespace-nowrap">desenvolvido por</span>
            <div className="h-7 w-auto flex items-center justify-center">
              <img
                src="https://storage.readdy-site.link/project_files/47bcf2e8-da50-493f-ab49-e49946c611e0/8236f754-af20-4345-ad91-8c6933fa7cfe_Screen-Shot-2025-10-23-at-8.43.35-AM.png?v=cfbf6309bac39fda8f2ec6f6a7068d3d"
                alt="Twogather Agency"
                className="h-7 w-auto object-contain opacity-60 group-hover:opacity-100 transition-opacity"
              />
            </div>
          </a>
        </div>
      </div>
    </footer>
  );
}